<template>
    <div>
        <form-select v-model="data.category" :label="$t('label.type')" :options="categoryOptions"
                     text-prop="text" value-prop="value" icon-prop="icon"
                     :rules="{required: true}" :disabled="disabled"/>

        <form-input v-model="data.title" :label="$t('label.title')" :rules="{max: 80}" :placeholder="selectedCategoryOption.title_placeholder" :disabled="disabled"/>

        <form-codearea v-model="data.message" :autofocus="!edit" :label="$t('label.content')" :rules="{required: true}" no-media no-headings :disabled="disabled"/>

        <client-only>
            <attach-cropped-image-form-inputs :title="$t('label.image')" prop="image" :data="data" :disabled="disabled" help-size="800x400px" help-ratio="3/2" :ratio="3/2"/>
        </client-only>
    </div>
</template>

<script>
import {EventTickerMessageCategory} from "@spoferan/spoferan-ts-core";
import FormInputsMixin from "../Form/FormInputsMixin";
import {mdiAlert, mdiCheck, mdiExclamation, mdiMessageTextOutline} from "@mdi/js";

export default {
    name: "TickerMessageFormInputs",

    mixins: [FormInputsMixin],

    computed: {
        categoryOptions() {
            return [
                {value: EventTickerMessageCategory.Text, text: this.$t('label.text'), title_placeholder: 'Live-Ticker', icon: this.getEventTickerMessageCategoryIcon(EventTickerMessageCategory.Text)},
                {value: EventTickerMessageCategory.Success, text: this.$t('label.success'), title_placeholder: 'Live-Ticker', icon: this.getEventTickerMessageCategoryIcon(EventTickerMessageCategory.Success)},
                {value: EventTickerMessageCategory.Warning, text: this.$t('label.warning'), title_placeholder: this.$t('label.warning'), icon: this.getEventTickerMessageCategoryIcon(EventTickerMessageCategory.Warning)},
                {value: EventTickerMessageCategory.Danger, text: this.$t('label.danger'), title_placeholder: this.$t('label.danger'), icon: this.getEventTickerMessageCategoryIcon(EventTickerMessageCategory.Danger)},
            ]
        },

        selectedCategoryOption() {
            return this.categoryOptions.find(option => option.value === this.data.category) ?? this.categoryOptions[0];
        }
    },

	methods: {
		getEventTickerMessageCategoryIcon(category) {
			switch (category) {
				case EventTickerMessageCategory.Success:
					return mdiCheck;
				case EventTickerMessageCategory.Warning:
					return mdiExclamation;
				case EventTickerMessageCategory.Danger:
					return mdiAlert;
			}
			return mdiMessageTextOutline;
		}
	}

}
</script>